import {
  registerTextCasingPlugin,
  registerTextOutlinePlugin,
  registerNameReorderPlugin,
} from 'utils'
import highlightDynamicTextPlugin from 'utils/tinyMCE/plugins/highlightDynamicTextPlugin'
import { removeEmptyCaseDetailDivPlugin } from 'utils/tinyMCE/plugins/removeEmptyCaseDetailDivPlugin'
import kerningPlugin from 'utils/tinyMCE/plugins/kerningPlugin'
import { registerCustomFontSizePlugin } from '@/utils/tinyMCE/plugins/registerCustomFontSizePlugin'
import { registerCustomLineSpacePlugin } from '@/utils/tinyMCE/plugins/registerCustomLineSpacePlugin'
import { registerCustomFontSelectPlugin } from '@/utils/tinyMCE/plugins/registerCustomFontSelectPlugin'

export const loadLocalPlugins = ({
  editor,
  updateHeight,
}: {
  editor: Editor
  updateHeight: () => void
}) => {
  editor.editorManager.PluginManager.add('casedetails', function () {
    // TinyMCE requires raw SVG strings for addIcon — sourced from @heroicons/react/24/solid/EllipsisVerticalIcon
    editor.ui.registry.addIcon(
      'kebab',
      '<svg width="24" height="24" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M10.5 6a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm0 6a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm0 6a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z" clip-rule="evenodd"/></svg>',
    )
    registerTextCasingPlugin({ editor })
    registerTextOutlinePlugin({ editor })
    registerNameReorderPlugin({ editor })
    registerCustomFontSizePlugin({ editor })
    registerCustomLineSpacePlugin({ editor })
    registerCustomFontSelectPlugin({ editor })
    highlightDynamicTextPlugin({ editor })
    removeEmptyCaseDetailDivPlugin({ editor })
    kerningPlugin({ editor, updateHeight })
  })
}

export default loadLocalPlugins
